import * as React from "react";
import { Link } from "gatsby";

import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import Old2005BlogPage from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—March 2005" />
	<Old2005BlogPage>
		<h2>March 2005</h2>




		<h3 className="blogdate">
		Wednesday, March 30, 2005
		</h3>





		<h4 className="blogitemtitle">
		Tired Tired TIRED!
		</h4>





			<div className="blogitembody">
			Yes, let's do that again! Stay up all night and long, then have a shower and walk to work! I have officially been awake for 29 hours!<br /><br />To start, last night I spent a few very rad hours in the recording studio at Music Center Canada! I got to record four songs last night and I have to say they sound pretty damned good to me! Best recording session I've ever been a part of so it was exciting for me. My new friend Josh Gwilliam was the master recording engineer, who sat back while his confident apprentice Nathan Fairweather ran the controls. I truly appreciated their time and the opportunity!<br /><br />Then Rebecca and I went to Dave's house and had a blast. I wanted to write a song about green tea and bronchitis, but no... Dave had to write an actual *good* song with relevance and meaning. So Rebecca, Dave and I recorded a "stripped down" version of the new song "All Alone", and I hope that Dave posts the pictures soon!<br /><br />Later we broke raw eggs in the street, played more guitar, and ate most of the food that Dave owned. Bean and cheese burritos are great especially when followed by icecream and chocolates.<br /><br />I'm going to bed as soon as I get home from work. If you are reading this... do not call me tonight.<br /><br />Links:<br /><br /><a href="http://davesimpsonmusic.com/">http://davesimpsonmusic.com/</a><br /><a href="http://www.musiccentrecanada.com/">http://www.musiccentrecanada.com/</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 10:07 AM &nbsp;

			</div>





		<h3 className="blogdate">
		Tuesday, March 29, 2005
		</h3>





		<h4 className="blogitemtitle">
		Sunday night again at Eddie Bo Dean's
		</h4>





			<div className="blogitembody">
			I found out last night that one of my favorite songs that Rebecca sings is an original! I forget what it is called, though... perhaps "Long and Stormy Night"? It's great, you should hear it. And last night Greg played a great cover of "One" by U2, which Rebecca sang backing vocals on. I have to agree with Dan - Eddie Bo Dean's is the best open mic in the city! There are some talented people that show up, and everyone gets a chance to play.<br /><br />Two sisters got up and played (seperately) their original tunes; they were very unique and... good! I believe their names are Alyssa and Anne... but I'm not sure. And I'm finally going to spell Kaley's name correct (there I just did it, I think).<br /><br />I had a rough time last night; didn't really feel solid while playing, and I forgot lyrics and chords left-right-and-center! But oh well, still played some cool songs... and thanks Rebecca for requesting "Mesmerize Me!"<br /><br />I was pretty tired last night, and am feeling pretty tired today, so I'll keep this post short. But Eddie's rocks, and so do Rebecca and Josh. So if you are reading this... go there on a Sunday night. And bring your instrument.
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 9:54 AM &nbsp;

			</div>





		<h3 className="blogdate">
		Sunday, March 27, 2005
		</h3>





		<h4 className="blogitemtitle">
		Aussie Pete at Wildwood
		</h4>





			<div className="blogitembody">
			The Wildwood crowd loves Aussie Pete (Pete Bourke)! They know which songs to request - they love his covers and his originals! I find Pete to be a one-man wall of sound, although he often plays with a group rather than by himself. His hard-strumming rhythm, alternate tunings and distinct voice captivate his audience very effectively. I found myself tapping and drumming my table and singing harmonies while enjoying my beer!<br /><br />Pete, thanks so much for letting me get up and play a few songs! Here's what I played on Pete's guitar:<br /><br />- Soundgarden - Rusty Cage<br />- The Tea Party - All My Charms<br />- Blue Rodeo - Hasn't Hit Me Yet<br /><br />After I played I met a few friendly folks; one of them even recognized All My Charms, which is rare. And Pete has some recommendations for me when I travel to Sydney and the Gold Coast (I believe, the one north of Brisbane), so I'll email him when the time comes for me to head north of Melbourne!<br /><br />Links:<br /><a href="http://www.petebourke.com/">http://www.petebourke.com/</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 9:25 PM &nbsp;

			</div>





		<h3 className="blogdate">
		Saturday, March 26, 2005
		</h3>





		<h4 className="blogitemtitle">
		Liquid Courage is good
		</h4>





			<div className="blogitembody">
			I just saw Liquid Courage play at Wolfman's Pub in Marda Loop (Calgary).... Very good!  Dan and Kali from Eddie Bo Dean's are plugged in and grooving in the key of funk/blues.  Very good.  I believe Nick is the name of the drummer, also from Eddie Bo Dean's and I feel bad that I can't remember his name.  Anyways, Kali is funky groovy as ever, and man can Dan play electric guitar.  Like really play it.  I recommend watching him play.
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 7:42 PM &nbsp;

			</div>





		<h3 className="blogdate">
		Tuesday, March 22, 2005
		</h3>





		<h4 className="blogitemtitle">
		Awesome night at Eddie Bo Dean's!
		</h4>





			<div className="blogitembody">
			Last night was very fun at Open Mic!<br /><br />Dave Simpson followed Rebecca and played a short set, including "The Wind Cries Mary" and his untitled song, which I think should be titled "Perfect"... but he'll figure it out. It's a good song, anyways. Then I followed and played:<br /><br />The Tea Party - All My Charms<br />Jesse Rivest - Mesmerize Me<br />The Tea Party - Oceans<br />Led Zeppelin - Stairway to Heaven (ha ha)<br /><br />I was very happy with the feedback on "Mesmerize Me"; I'm starting to wonder if it's the best song I've written? I sure like it, and so do others! I wish Élise could hear it! The Tea Party stuff was for Erin because she is so cool.<br /><br />I told Rebecca I had a surprise for her - a song that I wanted her to play recorder on... So she came up and I didn't want her to know what the song was until I started it - it was "Stairway to Heaven". She played the recorder for the beginning bit, then backed me up with some oooh's, and then sang the ending lyrics... it was fun!<br /><br />Greg showed up for the first time in weeks, which was great (he was sick), and he played an 80's set which put some grins on many faces. The best, of course, was "Jesse's Girl" by Rick Springfield - awesome!<br /><br />Other highlights:<br /><br />- Kali and Dan played some wicked Prince stuff... I say this every time but Kali is super funky. He's cool. Dan is super bluesy, he is cool.<br />- Dave and Rebecca cover a couple Damien Rice songs together, very awesome: ("Volcano" for sure, and I think also "The Blower's Daughter")<br />- Erin does back up vocal on a Damien Rice song ("Volcano"), too, plus her and Rebecca do a great "Got You (Where I Want You)" by the Flys. Very cool!<br />- I kicked Erin's ass at pool, except the one time when I sunk all her balls (ha - I wonder if she is reading this)! I also wonder if I am spelling her name right, I sure hope I am spelling everyone's names correctly.<br />- Josh played a couple songs, one from Ghosts of Modern Man (the new album that he recorded: "City of No Light"), and one from his band 800 Prospect. Josh is very cool on stage with his band, you should see them...<br /><br />Rebecca has a gig upcoming at Karma (April 16) that I want to check out; if you are reading this and live in Calgary then you should also check it out because wow she can sing. Ask her to do her Alicia Keys song (I'm sure she'll do it anyways) - it rocks. Greg says he comes to the Open Mic just to hear her sing that song. I think Dave also has an upcoming gig at Karma; just watch his site to find out more. Or email him. Or whatever.<br /><br />Erin's birthday is coming up and I think everyone is going Rollerskating... now when was the last time I went Rollerskating? I dunno, but I gotta attend this birthday party at least for that.<br /><br />Oh, uh... I called in sick today (work). Greg invited us to his place after the pub closed to continue jamming. Yes, that was very very cool. First, I got to play Greg's Les Paul Custom, which has a ridiculously awesome fretboard (plus a tremolo arm and three pickups, nuts)! Then we jammed out, about 4 or 5 guitars on the coolest Pearl Jam songs ever! I didn't get home till 5:00 and into bed until 6:00 this morning. You only live once, and I have paid sick days that I never use, so...<br /><br />By the way, I just listened to Missy Higgins' song: "All for Believing". I'm going to be listening to some more of her soon, she's from Melbourne. There's a link below. She's good. Yes. Also, try making use of The Archive for live music recordings. It's rad. Yes, rad is a word.<br /><br />Links:<br /><br /><a href="http://www.davesimpsonmusic.com">http://www.davesimpsonmusic.com</a><br /><a href="http://www.ghostsofmodernman.com">http://www.ghostsofmodernman.com</a><br /><Link to="/music/">http://www.jesserivest.com/music/</Link> (listen to "Mesmerize Me"... do it!)<br /><a href="http://www.damienrice.com">http://www.damienrice.com</a><br /><a href="http://www.800prospect.com">http://www.800prospect.com</a><br /><a href="http://www.missyhiggins.com">http://www.missyhiggins.com</a><br /><a href="http://www.archive.org">http://www.archive.org</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 10:39 AM &nbsp;

			</div>





		<h3 className="blogdate">
		Monday, March 21, 2005
		</h3>





		<h4 className="blogitemtitle">
		Two new mp3 files for download
		</h4>





			<div className="blogitembody">
			There are two new mp3 files to download on my site:<br /><br />1.  Mesmerize Me (newest song)<br />2.  Turning Point (a little instrumental I decided to record)<br /><br />I might put a recording up of "In the Kitchen" today as well, also an instrumental.<br /><br />Links:<br /><Link to="/music/">http://www.jesserivest.com/music/</Link>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 7:29 AM &nbsp;

			</div>





		<h3 className="blogdate">
		Sunday, March 20, 2005
		</h3>





		<h4 className="blogitemtitle">
		Saturday afternoon at Cafe Mauro
		</h4>





			<div className="blogitembody">
			Miserable weather in Calgary, however it was nice and warm at the cafe so I parked my ass on a stool and played guitar for a couple hours!  It was a bit busier than last time and it was nice to have an audience!  I almost made it through all my songs, but my voice started to tire and Sal and Jan wanted to head home.  I've been playing Mesmerize Me and I'm liking it, although I find the guitar a bit tricky - won't be long before I've got 'er down.
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 2:58 PM &nbsp;

			</div>









		<h4 className="blogitemtitle">
		Okay - this is the Guestbook
		</h4>





			<div className="blogitembody">
			Okay folks, I've decided that this particular journal entry is going to be my Guestbook, although you are welcome to comment on ANY journal entry! I am placing a link from my website to this page, calling it Guestbook.<br /><br />Links:<br /><br /><Link to="/music/">http://www.jesserivest.com/music/</Link>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 12:01 PM &nbsp;

			</div>









		<h4 className="blogitemtitle">
		I don't have a guestbook, but...
		</h4>





			<div className="blogitembody">
			I do have this journal!  At the bottom of each entry is an area that says "x Comments" where x is a number (usually zero).  Click on this and you can leave me a comment!  You can say who you are, leave your email, point to your website, whatever you like!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 7:41 AM &nbsp;

			</div>









		<h4 className="blogitemtitle">
		800 Prospect at the Black Swan
		</h4>





			<div className="blogitembody">
			Last night I Met Rebecca and Josh at Music Centre Canada and Josh showed me the recording studio.  It was sweet!  Josh recently recorded the album "City of No Light" for the band "Ghosts of of Modern Man"... it's pretty damned good, you should check them out - it's a heavy-dark style of music which has plenty of commercial appeal.<br /><br />Also, I had the opportunity to play a (~1990) Matchless DC-30 combo amp last night!  WOW, I am selling my Mesa/Boogie DC-3, yes I am.  When I come back from travelling I am getting a REAL amp, like this beauty.  Yes.<br /><br />Later we went to the Black Swan and watched Josh's band 800 Prospect play - very cool!  Josh really brings an energy to the show - I saw a different side of him last night that I had not seen before.  His stage presence is very energetic, but with style.  I think their gig started out a little rough, but by the end they glued together very well, and I must mention that the song "Break Away" was very cool, as well as their awesome cover of "Hotel California".<br /><br />Links:<br /><br /><a href="http://www.ghostsofmodernman.com/">http://www.ghostsofmodernman.com/</a><br /><a href="http://www.800prospect.com/">http://www.800prospect.com/</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 7:33 AM &nbsp;

			</div>





		<h3 className="blogdate">
		Wednesday, March 16, 2005
		</h3>






		<h4 className="blogitemtitle">
		Mesmerize Me is almost out there!
		</h4>





			<div className="blogitembody">
			So my friend Ming, along with Andrea, Luke and Maddie, is the first person(s) to hear my new song Mesmerize Me!  I'll be playing it again on Sunday night at Eddie Bo Dean's.  After that I will make it available on my site!<br /><br />Ming cooked a great dinner tonight - I've discovered that he is a great cook!  After dinner we did the Tim Tam dunk (which I sucked at, I better learn this before I go to Australia).  We sat around the table and talked, looked at some Holga pics that Ming took, and played a bit of music.  I also played Ming's Les Paul which was set up by Fretworks...  I must say that I will bring my Les Paul in for a setup after I return from travelling.  Miles does a great job!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 7:43 PM &nbsp;

			</div>





		<h3 className="blogdate">
		Tuesday, March 15, 2005
		</h3>






		<h4 className="blogitemtitle">
		Slept through my alarm this morning!!
		</h4>





			<div className="blogitembody">
			Another late (but great) night at Eddie Bo Dean's last night! I followed Rebecca on the mic and played the following:<br /><br />Lester Quitzau - Time Takes Time<br />Jesse Rivest - Crazy French Girl<br />Jesse Rivest - Deadbeat Blues<br />Joe Cocker - You are So Beautiful<br />Stone Temple Pilots - Plush<br />Sam Roberts - Don't Walk Away Eileen<br /><br />I went back up later and played:<br /><br />Victoria Williams - Crazy Mary<br />Blue Rodeo - Hasn't Hit Me Yet<br />Soundgarden - Rusty Cage<br />John Mayer - Comfortable<br /><br />I met a cool fellow from Australia named Daniel; he is from Bateau Bay (north of Sydney on the Central Coast) and is here on his honeymoon. He waited for my first set to finish before leaving, but before I played we talked a bit about Australia and he offered me a place to stay when I visit! Very friendly dude.<br /><br />My new friend Ming came and brought some friends, too! Ming won my auction (<a href="http://songauction.blogspot.com">http://songauction.blogspot.com</a>) so I am going to bring my guitar to his place on Tuesday night; he invited me for dinner. Very cool guy - in the future we might build a guitar amplifier together (experimental but fun). Ming says I inspired him to buy a slide and play slide guitar!<br /><br />Also, my friend Andrew came and he is becoming addicted to open mic... I think it is inspiring for him as he is new to guitar and is excited about learning to play a whole song through from start to finish. If I have time before I leave for Australia then I will help him with that. Oh, and Andrew is also keen on hearing Rebecca sing (as am I) - she has a great voice!<br /><br />Another fellow showed up that I recognized from Karma - I believe his name is Dave Simpson and he will have a website up in the near future (<a href="http://www.davesimpsonmusic.com">http://www.davesimpsonmusic.com</a>). He's quite good and mixes in a solid percentage of originals in his sets - he's confident and is lining up work for himself as a solo act in Calgary.<br /><br />And as always I appreciated watching Kali and Dan play! I even played bongos with them for a song. Kali is a very groove/funk oriented player and he sings, too. Dan is very bluesy and the two of them work well together. I hope I am spelling Kali's name correctly!<br /><br />I think this Friday I am going to carpool with Rebecca to Josh's gig (http://www.800prospect.com) at the Black Swan (Calgary south). Should be cool, I hear the band is quite good. Josh plays bass and provides backup vocals, I believe.
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 7:06 AM &nbsp;

			</div>





		<h3 className="blogdate">
		Monday, March 14, 2005
		</h3>






		<h4 className="blogitemtitle">
		Bad Luck at Cafe Mauro
		</h4>





			<div className="blogitembody">
			I went into the cafe yesterday and played for an hour, it was pretty dead - Sal and BB even started cleaning the place up, readying to go home.  At least Keith stopped in and listened for a while!  Not five minutes after I put my guitar away, the sun came out and people started entering the cafe.  I should have just sat down and played again because almost all off the tables filled and I would have had a decent little audience!  Oh well.  Still, practicing at Sal's on a Saturday is way better than practicing at home, by myself.  Sal and BB always appreciate hearing some live music while they work.
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 9:40 AM &nbsp;

			</div>





		<h3 className="blogdate">
		Thursday, March 10, 2005
		</h3>






		<h4 className="blogitemtitle">
		Australia in the near future!
		</h4>





			<div className="blogitembody">
			So I am skipping out on the open mic tonight, instead I have a fire going and I am going to practice my new song "Mesmerize Me".  I'm just listening to Xavier Rudd and the fire crackling while I post this update.<br /><br />I'd like to announce that I will be going to Australia soon!  End of April or end of May!  I am very excited - I have the chance to see Asia for a bit, too.  I am bringing my guitar with me and plan to keep updating this journal with stories from open mics in Australian cities!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 4:13 PM &nbsp;

			</div>





		<h3 className="blogdate">
		Monday, March 07, 2005
		</h3>






		<h4 className="blogitemtitle">
		Great night at Eddie Bo Dean's
		</h4>





			<div className="blogitembody">
			Well, if it isn't obvious already, my favorite open mic is at Eddie Bo Dean's.  Tonight I played the following:<br /><br />Black Crowes - Talks to Angels<br />Xavier Rudd - Solace Amongst the Sin<br />Bob Marley (Xavier Rudd) - No Woman No Cry<br />Tragically Hip - Opiated<br />Tom Petty - Wildflowers<br />Tea Party - Winter Solstice<br />Tea Party - Sun Going Down<br />Jesse Rivest - Worth the Wait<br />John Mayer - Comfortable<br /><br />Erin and I got some poutine and added some ketchup to it; everyone thought we were sick but we loved it.  Afterwards we were both burping and holding back on flatulence.  Rebecca got up with me and sang harmonies on Comfortable which was a real treat!  Rebecca has an amazing voice, although I'm sure I've mentioned that before.  She closed the night playing my guitar, so I got to sit in the audience and hear my guitar... I must say I LOVE it!   I love the sound of my guitar, I am very happy with my K&K Pure Western pickup inside my Simon &amp; Patrick Sunburst Cedar High Gloss.<br /><br />I am really feeling like I've made some good friends, mainly Josh, Rebecca and Erin.  I will miss these guys and this jam when I leave Canada for a while this year.  This year and part of last year have been the best part of my life.  I have embraced my inner musical power and am working with it every day.  I fell in love with a girl that is RIGHT for me, a girl that brings me more harmony and happiness than she can possibly know.  And finally, after 28 years, I am going on a trip over seas, to Australia and possibly Asia.  I am bringing my guitar and camera, and I am going to have an adventure, and I will keep my eyes open for the girl I love.
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 10:57 PM &nbsp;

			</div>





		<h3 className="blogdate">
		Friday, March 04, 2005
		</h3>






		<h4 className="blogitemtitle">
		Tried a new open mic:  Jackdaw's Pub
		</h4>





			<div className="blogitembody">
			Well, new to me, I mean.  Nate and Sher (I hope the names are correct) have been running the open mic for almost a year.  I showed up just before Rebecca and Josh appeared (they run the Eddie Bo Dean's open mic).  The atmosphere is warm with a wood log cabin feel and lanterns on the walls.  A little smoky but hey, its a Calgary pub so that should be expected.  Honorable mention to a fellow named Ben, who hosts his own open mic somewhere else on Sundays (can't remember where) - he has an amazing quality to his voice and his rhythm and I commended him on it afterwards.  I played the following:<br /><br />Lester Quitzau - Broken Heart<br />Jesse Rivest - Worth the Wait<br />The Tea Party - All My Charms<br /><br />The whole place was silent for Broken Heart and Worth the Wait; that was very cool.  People liked the whole set and they asked who Lester Quitzau is.  I am now a Lester Quitzau promoter - he's a very laid back and grounded fellow who writes very cool songs and I think you all should listen to his stuff.  He's a very talented guitarist, too.<br /><br />I was asked to play Messenger by the Tea Party so I did so, and then Rebecca asked if I could play Comfortable by John Mayer and if she could sing harmony with me.  We tried but it has been a long time and I kept screwing it up, so I promised her I would practice it again for this Sunday or an upcoming Sunday... it will be very cool to have Rebecca sing harmony with me.  She has a great voice!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 7:36 AM &nbsp;

			</div>





		<h3 className="blogdate">
		Wednesday, March 02, 2005
		</h3>






		<h4 className="blogitemtitle">
		Tuesday afternoon at Cafe Mauro
		</h4>





			<div className="blogitembody">
			I stopped in at the cafe after work and played a few songs. It was the first time Sal heard the songs I wrote; I think he knows where a lot of my recent songs come from so it was likely interesting for him. It was dead in the cafe while I played, save a regular fellow named Chris who had an afternoon omelette. Chris thanked me for the tunes on his way out, which was cool! I might play again tomorrow afternoon, between my regular work shift and some overtime in the evening. I believe I'll be there again on Saturday, too, to have some food and a wine taste-off with Sal, as well as playing some tunes.<br /><br />Links:<br /><Link to="/">http://www.jesserivest.com/</Link>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 4:11 PM &nbsp;

			</div>





		<h3 className="blogdate">
		Tuesday, March 01, 2005
		</h3>






		<h4 className="blogitemtitle">
		New Song - Mesmerize Me
		</h4>





			<div className="blogitembody">
			I wrote a new song tonight, called Mesmerize Me.  It's not up on my site yet... I plan on doing something a little different to release this song.  I like this song a lot, it's fun!  I'll post more about it soon.
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 6:38 PM &nbsp;

			</div>










		<h4 className="blogitemtitle">
		Sunday night again at Eddie Bo Dean's
		</h4>





			<div className="blogitembody">
			Another good Sunday night at Eddie Bo Dean's.  I had a nice entry typed up and then I lost it, so now you get the point form version, sorry:<br /><br />- I played the following songs:<br />     - Lester Quitzau - Waiting<br />     - Kevin Kane - The Sinking Song<br />     - The Tea Party - The Messenger<br />     - The Tragically Hip - 38 Years Old<br /><br />- Dan and Kali were joined by a fellow named Chad to played percussion/beat with his microphone and his mouth.... very cool.  And Dan rapped some "Rage-style" lyrics, too.<br /><br />- Josh told me that Mark Sampson has a new amplifier company (he started Matchless and contributed at BadCat):  Star Amplifiers.  Check out the link below, he makes very very sweet sounding amps.<br /><br />- Going to try Jackdaw's Pub on Wed night for a new open mic; Rebecca's friend (Nick?) hosts it.  I think Rebecca will meet me there.<br /><br />- Youssou Seck never appeared, but I didn't really expect him to.<br /><br />Links:<br /><br /><a href="http://www.staramplifiers.com/">http://www.staramplifiers.com/</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 6:32 PM &nbsp;

			</div>




		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
